import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface userDetails {
  userDetails?: User
  jiraDetails?: JiraDetail
  openProjectDetails?: OpenProjectDetail,
  isSessionExpired?: boolean
  isRefresh?: boolean
}

export interface User {
  id: string
  name: string
  email_address: string
  department: string
  title: string
  manager_id: string
  manager?: string
  created_at: string
  parentId: string
  userName?: string
  hiringDate?: string
  appointmentUrl?: string
  imageUrl: string
}

export interface JiraDetail {
  self: string
  accountId: string
  accountType: string
  emailAddress: string
  displayName: string
  active: boolean
  timeZone: string
  locale: string
}


export interface OpenProjectDetail {
  _type: string
  id: string
  name: string
  createdAt: string
  updatedAt: string
  login: string
  admin: boolean
  firstName: string
  lastName: string
  email: string
  avatar: string
  status: string
  identityUrl: any
  language: string
  _links: Links
}

export interface Links {
  self: Self
  memberships: Memberships
  showUser: ShowUser
  updateImmediately: UpdateImmediately
  auth_source: AuthSource
}

export interface Self {
  href: string
  title: string
}

export interface Memberships {
  href: string
  title: string
}

export interface ShowUser {
  href: string
  type: string
}

export interface UpdateImmediately {
  href: string
  title: string
  method: string
}

export interface AuthSource {
  href: string
  title: string
}


export interface userState {
  user: userDetails | null,
  opSessionId: string | null,
  jiraSessionId: string | null,
  opState: string,
  jiraState: string
}

export const initialState: userState = {
  user: null,
  opSessionId: null,
  jiraSessionId: null,
  opState: 'null',
  jiraState: 'null',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserState: (state, action: PayloadAction<userDetails>) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
    clearUserState: (state) => {
      state.user = null
    },
    setSessionExpired: (state, action: PayloadAction<boolean>) => {
      if (state.user) {
        state.user.isSessionExpired = action.payload;
      }
    },
    setUserOpSession: (state, action: PayloadAction<string | null>) => {
      state.opSessionId = action.payload
    },
    setUserJiraSession: (state, action: PayloadAction<string | null>) => {
      state.jiraSessionId = action.payload
    },
    setUserOpState: (state, action: PayloadAction<string>) => {
      state.opState = action.payload
    },
    setUserJiraState: (state, action: PayloadAction<string>) => {
      state.jiraState = action.payload
    },
    setUserOpDetails: (state, action: PayloadAction<OpenProjectDetail>) => {
      if (state.user) {
        state.user.openProjectDetails = action.payload;
      }
    },
    setUserJiraDetails: (state, action: PayloadAction<JiraDetail>) => {
      if (state.user) {
        state.user.jiraDetails = action.payload;
      }
    },
    setIsRefresh: (state, action: PayloadAction<boolean>) => {
      if (state.user) {
        state.user.isRefresh = action.payload;
      }
    }
  }
});

export const {
  setUserState, clearUserState, setUserOpSession, setUserJiraSession, setUserJiraState,
  setUserOpState, setUserOpDetails, setUserJiraDetails,
  setIsRefresh
} = userSlice.actions;

export default userSlice.reducer;
